var $13248984d46c1e4f$exports = {};
$13248984d46c1e4f$exports = {
    "loading": `L\xe4ser in...`,
    "loadingMore": `L\xe4ser in mer...`
};


export {$13248984d46c1e4f$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
